import { Controller as BaseController } from 'stimulus'
import { useDebounce, useWindowResize } from 'stimulus-use'

export class Controller extends BaseController {
    static targets = ['button', 'link'];
    static debounces = ['windowResize'];

    /**
     * Listen for when the user resizes the browser window...but only every 2 milliseconds
     * @link https://github.com/stimulus-use/stimulus-use/blob/main/docs/use-debounce.md
     * @link https://github.com/stimulus-use/stimulus-use/blob/main/docs/use-window-resize.md
     */
    connect() {
      useDebounce(this)
      useWindowResize(this)
    }

    /**
     * When one of the interactive targets is visually-hidden,
     * make sure it's also hidden from assistive technologies.
     * By default (on initial render), the link will be hidden.
     */
    windowResize() {
      const buttonStyles = window.getComputedStyle(this.buttonTarget)
      const buttonDisplay = buttonStyles.getPropertyValue('display')
      const buttonIsHidden = buttonDisplay === 'none'

      this.buttonTarget.setAttribute('tabindex', buttonIsHidden ? '-1' : '0')
      this.linkTarget.setAttribute('tabindex', buttonIsHidden ? '0' : '-1')
    }
}
